<template>
	<div class="portal">
		<div class="protal-title">
			热门{{type === 'web' ? '综合门户' : '移动媒体'}}
			<span class="text-lighter">
				优选{{type === 'web' ? '全网精品综合门户' : '移动端' }}媒体，{{type === 'web' ? '高价值曝光' : '精品流量' }}引爆品牌传播
			</span>
		</div>
		<div class="protal-content clearfix contain" v-if='this.proData.length'>
			<div style='padding: 0 30px'>
				<transition-group name="list-complete" tag="span" class='clearfix'>
					<div class="protal-icons" :class='type === "web" ? "pc" : "mobile"' v-for='(item, index) in proData' v-bind:key='item'>
						<a :href='item.domain' target="_blank" v-if='type === "web"'>
							<img :src='imgUrl + item.logo' alt="">
						</a>
						<a v-else @click='showDetail(index)'>
							<img :src='imgUrl + item.logo' alt="">
						</a>
						<div class="text-center" style="margin-top: 10px; height: 16px; overflow: hidden">{{item.name}}</div>
					</div>
				</transition-group>
			</div>
			<div class="turn clearfix">
				<div class="turn-left pull-left" @click='changePage(-1)'>
					<div class="glyphicon glyphicon-circle-left"></div>
				</div>
				<div class="turn-right pull-right" @click='changePage(1)'>
					<div class="glyphicon glyphicon-circle-right"></div>
				</div>
			</div>
		</div>
		<div v-else style="text-align: center;margin-bottom: 30px">
			暂无数据！
		</div>
		<Modal :modal='modal' v-if='this.proData.length' class='modal-special'>
			<div slot="body" style="position: relative">
				<span class="pull-right" style="font-size: 18px;cursor: pointer;position: absolute;top: -24px;right: 0;width: 80px
				;height:40px;text-align: center;background-color: #f5700e;color: white;line-height: 40px;box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);" @click='hideModal()'>关闭</span>
				<div class="modal--body">
					<div class="modal--header">
						广告位案例展示
					</div>
					<div class="modal--content">
						<img :src='imgUrl + proData[nowIndex].preview_pic' alt="">
						<div class="modal--content--right">
							<div class="modal-des">
								<div class="des-line">{{proData[nowIndex].name}}{{+proData[nowIndex].type === 2 ? '(WAP)' : '(APP)'}}</div>
								<div class="des-line">广告位查看路径：{{proData[nowIndex].preview_url}}</div>
								<div class="des-line">{{proData[nowIndex].m_domain !== "" ? "网址：" : ""}}{{proData[nowIndex].m_domain}}</div>
							</div>
							<div class="modal--footer">
								<div class="protal-content clearfix contain" v-if='this.proData.length'>
									<div class="turnbtn"  @click='changePage(-1)'>
										<div class="glyphicon glyphicon-turn-left"></div>
									</div>
									<div style="width: 498px;float: left" >
										<transition-group name="list-complete" tag="span" class='clearfix'>
											<div class="protal-icons mobile" v-for='(item, index) in proData' v-bind:key='item' :class='index === nowIndex ? "active" : ""'>
												<a @click='changeIndex(index)'>
													<img :src='imgUrl + item.logo' alt="">
												</a>
												<div style="margin-top: 5px;text-align: center">{{item.name.substring(0, 4)}}</div>
											</div>
										</transition-group>
									</div>
									<div class="turnbtn" @click='changePage(1)'>
										<div class="glyphicon glyphicon-turn-right"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Modal from './modal'
	export default {
		data () {
			return {
				type: this.$route.params.type,
				currentPage: 1,
				totalpage: '',
				proData: [],
				nowIndex: 0,
				modal: {
					show: false
				}
	 		}
		},
		watch: {
			'$route' (to, from) {
				this.modal.show = false
				this.$set(this, 'type', to.params.type)
				this.$set(this, 'currentPage', 1)
				this.getPorData(to.params.type)
			}
		},
		mounted () {
			this.getPorData(this.$route.params.type)
		},
		components: {
			Modal
		},
		methods: {
			showDetail (index) {
				this.$set(this.modal, 'show', true)
				this.changeIndex(index)
			},
			changeIndex (index) {
				this.$set(this, 'nowIndex', index)
			},
			changePage (index) {
				let newPage = this.currentPage + index
				if (newPage < 1 || newPage > this.totalpage) {
					newPage = newPage < 1 ? this.totalpage : 1
				}
				this.$set(this, 'nowIndex', 0)
				this.$set(this, 'currentPage', newPage)
				this.getPorData()
			},
			hideModal () {
				this.modal.show = false
			},
			getPorData () {
				let params = {}
				params.type = this.type === 'web' ? 1 : 2
				params.pagesize = this.type === 'web' ? 15 : 12
				params.page = this.currentPage
				this.$http.get(`${this.baseUrl}boutique`, {params: params})
				.then((res) => {
					if (JSON.parse(res.data).code === 1) {
						this.$set(this, 'proData', Array.prototype.slice.call(JSON.parse(res.data).result.datalist, 0))
						this.$set(this, 'totalpage', JSON.parse(res.data).result.totalpage)
					}
				})
			}
		}
	}
</script>

<style lang='less'>
.modal-special{
	&.modal-mask{
		.modal-confirm{
			width: 1024px;
			height: 540px;
			min-height: 540px;
			height: 540px;
			overflow: hidden;
			border-radius: 10px;
			background-color: #eee;
			.modal-content{
				width: 100%;
				.modal-body{
					width: 100%;
					padding: 0;
					padding-top: 23px;
					.des-line{
						line-height: 50px;
					}
				}
			}
			.modal--content--right{
				.modal-des{
					height: 200px;
				}
				.modal--footer{
					margin-top: 20px;
					.protal-icons{
						width: 58px;
						height: 58px;
						margin-left: 20px;
						margin-bottom: 40px;
					}
				}
			}
		}
	}
}
.modal--body{
	overflow: hidden;
	.modal--header{
		padding-left: 76px;
		font-size: 30px;
	}
	.modal--content{
		height: 446px;
		padding: 20px 50px 20px 50px;
		img{
			display: inline-block;
			height: 447px;
			width: 261px;
		}
		.modal--content--right{
			display: inline-block;
			height: 250px;
			float: right;
			width: 560px;
			.modal-des{
				height: 250px;
				width: 560px;
				padding: 20px;
				font-size: 16px;
				background-color: #e0e0e0;
				.des-line{
					line-height: 65px;
				}
			}
		}
	}
	.modal--footer{
		box-sizing: border-box;
		width: 560px;
		.turnbtn{
			float: left;
			font-size: 40px;
			color: #333;
			margin-top: 60px;
			cursor: pointer;
			.glyphicon{
				&:hover{
					color: #f7700d;
				}
			}
		}
		.protal-content{
			overflow: hidden;
			.protal-icons{
				margin-left: 88px;
				&.active{
					box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.2);
				}
			}
		}
	}
}
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 0px;
}
.list-complete-enter, .list-complete-leave-active {
  opacity: 0;
  transform: translateX(200px);
}
.list-complete-leave-active {
  position: absolute;
}
.portal{
	min-height: 640px;
	background-color: #eee;
	.protal-title{
		padding-top: 50px;
		text-align: center;
		font-size: 26px;
		span{
			font-weight: normal;
			display: block;
			font-size: 15px;
			margin-top: 20px;
			margin-bottom: 50px;
		}
	}
	.protal-content{
		overflow: hidden;
		position: relative;
		.protal-icons{
			width: 100px;
			/*cursor: pointer;*/
			height: 100px;
			float: left;
			transition: all 0.4s;
			margin-left: 108px;
			margin-bottom: 60px;
			border-radius: 5px;
			img{
				border-radius: 5px;
				display: block;
				width: 100%;
				height: 100%;
			}
			&.pc{
				width: 170px;
				height: 75px;
				margin-bottom: 60px;
				margin-left: 72.5px;
			}
			&.pc:nth-child(5n+1) {
				margin-left: 0;
			}
			&.mobile:nth-child(6n+1){
				margin-left: 0;
			}
			&.pc:hover{
				box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.2);
			}
			&,.mobile{
				a{
					cursor: pointer;
				}
			}
			&.mobile:hover{
				box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.2);
			}
		}
		.protal-icons:hover{
			/*box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.2);*/
		}
	}
	.turn{
		padding-bottom: 40px;
		margin: 0 auto;
		width: 100px;
		font-size: 28px;
		*{
			cursor: pointer;
		}
		*:hover{
			color: #4285f4;
		}
	}
}
</style>



// WEBPACK FOOTER //
// portal.vue?14b3f2ab